import * as redux from 'redux';
// import { message, Button } from 'antd';
// import axios from "axios";

//Actions
export const CART_COUNT_UPDATE = "cartcount";
export const COMPARE_COUNT_UPDATE = "comparecount";

const initialState={
    count:0,
}

const cartReducer = (state = initialState, action) =>{
    // console.log(action);
    switch(action.type){
        case CART_COUNT_UPDATE:{
            return {...state, count:action.value};
            break;
        }
        default:{
            return state;
        }
    }
}

const compareReducer = (state = initialState, action) =>{
    // console.log(action);
    switch(action.type){
        case COMPARE_COUNT_UPDATE:{
            return {...state, count:action.value};
            break;
        }
        default:{
            return state;
        }
    }
}

const rootReducer  = (state = initialState, action) =>{
    return{
        cart: cartReducer(state.cart, action),
        compare: compareReducer(state.compare, action),
    }
}

const store=redux.createStore(rootReducer);
export default store;